/** @format */

import GridItem from '../../../../../components/Grid/GridItem';
import I18n from '../../../../../components/Translate/I18n';
import GridContainer from '../../../../../components/Grid/GridContainer';
import CheckBoxSimple from '../../../../../components/Form/CheckBoxSimple';
import CustomInputExtNumber from '../../../../../components/CustomInput/CustomInputExtNumber';
import CustomTextButtom from '../../../../../components/Buttons/CustomTextButton';
import React, { useEffect, useState } from 'react';
import CustomInputExt from '../../../../../components/CustomInput/CustomInputExt';

interface MultiInputPropsInterface {
    parameter: any;
    parameterKey: string;
    createValuesFromForm: (paramName: string, objectValue: object) => void | null;
    assignedValue?: any;
    isBME?: boolean;
}

export const DefaultInput = (props: MultiInputPropsInterface): React.ReactElement => {
    const { parameter, parameterKey, createValuesFromForm, assignedValue } = props;
    const [inputValue, setInputValue] = useState<number | null>(assignedValue ? assignedValue.default : null);
    const [isRequired, setIsRequired] = useState<boolean>(assignedValue ? assignedValue.required : parameter.required);

    return (
        <GridContainer style={{ paddingBottom: 25 }}>
            <GridItem xs={4}>
                <I18n trans={'prov:feature.param_name'} valueObject={{ param_name: parameterKey }} />
            </GridItem>
            <GridItem xs={8}>
                <GridContainer>
                    <GridItem xs={12}>
                        <CheckBoxSimple
                            label={'prov:feature.required'}
                            checked={isRequired}
                            callback={(): void => {
                                setIsRequired(!isRequired);

                                let finalObject = {
                                    default: inputValue,
                                    required: !isRequired,
                                };

                                createValuesFromForm(parameterKey, finalObject);
                            }}
                        />
                    </GridItem>
                    <GridItem xs={12}>
                        <CustomInputExt
                            labelText={'prov:feature.default'}
                            name="default"
                            value={inputValue}
                            onChange={(event: any): void => {
                                setInputValue(event.target.value);

                                let finalObject = {
                                    default: event.target.value,
                                    required: isRequired,
                                };

                                createValuesFromForm(parameterKey, finalObject);
                            }}
                        />
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem xs={12}></GridItem>
        </GridContainer>
    );
};
